var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('date-picker',{ref:"dialog",staticClass:"datepicker",attrs:{"placeholder":_vm.label,"color":this.$vuetify.theme.dark
        ? this.$vuetify.theme.themes.dark.primary
        : this.$vuetify.theme.themes.light.primary,"wrapper-submit":true,"append-to":"body","locale":_vm.$i18n.locale,"localeConfig":{
      fa: {
        //dow: 6,
        dir: 'rtl',
      },
      en: {
        dir: 'ltr',
      },
    },"disabled":_vm.disabled,"popover":false,"input-attrs":{ style: { width: '100% !important' } }},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }